var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAhrFilledIconThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.026 0C19.7033 0 17.7076 1.43027 16.875 3.45703H22.026C23.0004 3.45703 23.8916 3.99082 24.351 4.8498C24.8104 5.71172 24.7594 6.74766 24.2197 7.55684L21.8379 11.1293C24.9478 11.2455 27.5924 8.72924 27.5924 5.56641C27.5924 2.49727 25.0951 0 22.026 0Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2875 28.3834L13.5324 25.3034V20.4223L22.7597 6.58125C23.1478 5.99977 22.7318 5.21484 22.0285 5.21484H11.3902L9.73084 0.582422C9.60604 0.233203 9.27439 0 8.9035 0H3.2785C2.79334 0 2.39959 0.39375 2.39959 0.878906C2.39959 1.36406 2.79334 1.75781 3.2785 1.75781H8.28475L9.52283 5.21484H3.2785C2.57602 5.21484 2.15871 5.99912 2.54725 6.58125L11.7746 20.4223V25.3034L7.01947 28.3834C6.69258 28.5952 6.54404 28.9967 6.65443 29.3702C6.76482 29.7437 7.10783 30 7.49731 30H17.8098C18.1992 30 18.5423 29.7437 18.6527 29.3702C18.7629 28.9967 18.6144 28.5952 18.2875 28.3834ZM6.2492 8.96484L4.92088 6.97266H10.1527L10.9379 9.16406C11.9121 9.31535 12.3559 9.46342 12.9564 9.5877L12.0201 6.97266H20.3861L18.4332 9.90234H15.9922C14.9726 9.90234 13.9543 9.79688 12.9564 9.5877L13.9496 12.3598C14.1555 12.9336 13.7282 13.5352 13.1222 13.5352C12.7613 13.5352 12.4232 13.3119 12.2949 12.9527L10.9379 9.16406C9.36164 8.91756 8.3819 8.96484 6.2492 8.96484Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhrFilledIconThree);
export default __webpack_public_path__ + "static/media/ahr-filled-icon-three.e8d7a424ef1e2cbeb4b0c2ba3f649c06.svg";
export { ForwardRef as ReactComponent };